import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Card from '~/pages/Sistema/componentes/Card';
import Button from '~/componentes/Button';
import { Scrollbars } from 'react-custom-scrollbars';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  min-width: 0;
  max-width: 100%;
  overflow-x: hidden;

  .row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin: 0;

    .col {
      padding: 0.5em;
      flex-shrink: 0;
    }

    .col.w1 {
      width: 5em;
    }
    .col.w2 {
      width: 10em;
    }
    .col.w3 {
      width: 15em;
    }
    .col.w4 {
      width: 20em;
    }
    .col.w5 {
      width: 25em;
    }
    .col.w6 {
      width: 30em;
    }

    .center {
      text-align: center;
    }
  }

  .body {
    flex: 1;
    min-height: 0;

    .card-header {
      background: ${Colors.Color2};

      p {
        font-weight: 700;
        color: ${Colors?.Color4};
      }
    }
  }
  .display-oc {
    overflow-x: auto !important;
    max-width: 100% !important;
  }

  .pagination-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1em;

    .pagination {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
      gap: 0.6em;
    }

    .pag-number {
      background: ${Colors.Color2};
      border-radius: 2em;
      padding: 0.2em 0.9em;
      font-weight: 700;
      color: ${Colors.Color4};
    }
  }

  .content-os {
    background: ${Colors.Color13};
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    /* height: 100%; */
    border-radius: 1em;
    padding: 1.1em;
    /* display: flex;
    flex-direction: column; */
    /* overflow: hidden; */

    .header {
      flex-shrink: 0;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;

      .titulo {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background: ${Colors.Color2};
        border-radius: 0.4em;
        padding: 0.15em 0.8em 0.15em 0.3em;
        width: fit-content;

        img {
          width: 1.4em;
        }

        .title {
          font-size: 0.8125em;
          font-weight: 700;
          color: ${Colors?.Color7};
          margin-left: 0.5em;
        }
      }

      .div-right {
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: flex-end;
        height: fit-content;

        .pagination {
          margin-left: 1em;
          display: flex;
          align-items: center;
          flex-direction: row;
          justify-content: flex-end;
          height: fit-content;
        }

        .btn-excel,
        .btn-pdf {
          height: 1.8em;
          width: 1.8em;
          padding: 0em;
          font-size: 0.88em;
          font-weight: 600;
          background: ${Colors.Color4};
          border: 0.25em solid ${Colors.Color4};
          border-radius: 0.4em;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 1em;

          img {
            width: 1em;
          }
        }
      }

      .div-icone {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background: ${Colors.Color2};
        border-radius: 0.4em;
        padding: 0.15em 0.8em 0.15em 0.3em;
        width: fit-content;
        margin-bottom: 1.5em;

        img {
          width: 1.4em;
        }

        .title {
          font-size: 0.7125em;
          font-weight: 700;
          color: ${Colors?.Color7};
          margin-left: 0.5em;
        }
      }
    }
  }
`;

export const InputContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  border: 1px solid ${Colors.Border_Color_1};
  background-color: transparent;
  border-radius: 12px;
  padding: 16px;

  margin-top: 0.8em;
  margin-bottom: 0.8em;

  box-shadow: rgba(0, 0, 0, 0.3) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
`;

export const InputContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
  width: 100%;

  & > div {
    min-width: 160px;
    flex: 1;
  }
`;

export const ThisCard = styled(Card)`
  margin-bottom: 0.7em;
  padding: 0.8em;
  border-radius: 1em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: fit-content;
  height: fit-content;
  position: relative;
  overflow: hidden;
  background: ${localStorage.getItem('tema') == 'E' ? Colors.Color26 : Colors.Color2};
  box-shadow: none !important;

  ${props => {
    if (props?.ativo) {
      return `border: 0.1em solid ${Colors.Color8};`;
    }
  }}

  .row {
    .col {
      p {
        font-size: 0.7em;
        font-weight: bold;
        color: ${Colors.Color14};

        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
      }
    }
  }
`;

export const ThisProgress = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  content: '';
  width: ${props => props?.width};
  height: 1em;
  border-radius: 1em;
  background: ${props => props?.backgound};
`;

export const ScrollOS = styled(Scrollbars)`
  width: calc(100%) !important;
  min-width: 0 !important;
  max-width: 100% !important;
  overflow-x: hidden !important;
`;

export const ScrollOSPage = styled(Scrollbars)`
  width: calc(100%) !important;
`;

export const PageButtonNumber = styled(Button)`
  position: relative;
  background: none;
  border: none;
  font-size: 0.9em;
  padding: 0.1em 0.7em;
  margin-left: 0.25em;
  margin-right: 0.25em;

  ${props => {
    if (props?.ativo) {
      return `
        color: ${Colors.Color13};
      `;
    } else {
      return `
        color: ${Colors.Color13};
      `;
    }
  }}

  :hover {
    color: ${Colors.Color13};

    p {
      color: ${Colors.Color13};
    }
  }

  ${props => {
    if (props?.ativo) {
      return `
        span {
          position: absolute;
          content: "";
          display: block;
          background: ${Colors.Color4};
          width: 100%;
          height: 100%;
          margin-left: -0.7em;
          margin-top: -0.1em;
          border-radius: 0.5em;
          transition: 1s;
        }
      `;
    } else {
      return `
        span {
          position: absolute;
          display: none;
          content: "";
          width: 0;
          height: 0;
          transition: 1s;
        }

        p {
          color: ${Colors.Color14};
        }
      `;
    }
  }}

  :hover span {
    display: block;
    background: ${Colors.Color4};
    width: 100%;
    height: 100%;
    margin-left: -0.7em;
    margin-top: -0.1em;
    border-radius: 0.5em;
  }

  p {
    position: relative;
  }
`;

export const StatsRow = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 0.8em;
  margin-bottom: 0.3em;
`;

export const StatCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  flex: 2 1 26em;
`;

export const StatCardRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.6rem;
`;

export const StatCard = styled.div`
  background: ${localStorage.getItem('tema') == 'E' ? Colors.Color26 : Colors.Color2};
  border-left: 0.2em solid ${Colors.Color4};
  border-radius: 0.5em;
  padding: 0.7em 1.1em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.25em;
  flex: 1 1 9em;
  min-width: 9em;
  /* margin-bottom: 0.6rem; */

  .label {
    font-size: 0.68em;
    font-weight: 600;
    color: ${Colors.Color14};
    white-space: nowrap;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    opacity: 0.85;
  }

  .value {
    font-size: 1.35em;
    font-weight: 700;
    color: ${Colors.Color4};
    white-space: nowrap;
  }
`;

export const ResumoStatusCard = styled.div`
  background: ${localStorage.getItem('tema') == 'E' ? Colors.Color26 : Colors.Color2};
  border-radius: 0.5em;
  padding: 0.7em 1.1em;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1em;
  flex: 2 1 26em;
  min-width: 20em;
`;

export const ChartWrapper = styled.div`
  flex-shrink: 0;
  width: 7em;
  margin-left: auto;
`;

export const Status = styled.ul`
  font-size: 0.9em;
  font-weight: 600;
  color: ${Colors.Color14};
  width: 100%;
`;

export const ProposalStateList = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.4em;
  padding: 0.12em 0;

  span {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    font-size: 0.72em;
    font-weight: 500;
    color: ${Colors.Color14};
    min-width: 56px;

    &:first-child {
      justify-content: flex-start;
      flex: 1;
      font-weight: 400;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:before {
        content: '';
        display: inline-block;
        flex-shrink: 0;

        width: 0.5rem;
        height: 0.5rem;
        margin-right: 0.4rem;

        border-radius: 50%;
        background-color: ${props => props.color};
      }
    }
  }
`;

export const PageButtonIcon = styled(Button)`
  background: ${Colors.Color1};
  width: 1.3em;
  height: 1.3em;
  border-radius: 0.3em;
  border: none;
  color: ${Colors.Color4};
  font-size: 0.8em !important;
  margin-left: 0.25em;
  margin-right: 0.25em;

  :hover {
    background: ${Colors.Color4};
    color: ${Colors.Color13};
  }
`;
